import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormAsset,
  BackendMutationUpdateLongFormAssetArgs,
} from 'src/types/backend';

import { FRAGMENT_LONG_FORM_ASSET_FULL } from './schema';

const MUTATION = gql`
  mutation UpdateLongFormAsset(
    $longFormAssetId: ID!
    $contentHtml: String
    $contentMarkup: [ContentMarkupInput!]
    $name: String
    $assetType: AssetTypeEnum
    $generationTool: GenerationToolEnum
    $forceScoring: Boolean
    $scoringMethod: ScoringMethodInput
  ) {
    updateLongFormAsset(
      longFormAssetId: $longFormAssetId
      contentHtml: $contentHtml
      contentMarkup: $contentMarkup
      name: $name
      assetType: $assetType
      generationTool: $generationTool
      forceScoring: $forceScoring
      scoringMethod: $scoringMethod
    ) {
      ...LongFormAssetFull
    }
  }
  ${FRAGMENT_LONG_FORM_ASSET_FULL}
`;

export const updateLongFormAsset = async (
  variables: BackendMutationUpdateLongFormAssetArgs
): Promise<BackendLongFormAsset | undefined> => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: { traceAcRequests: true },
  });
  return getSingleProp<BackendLongFormAsset>(response.data);
};
